// What each Building readiness area says, as its tile on the Building readiness page
// shows it. The project Overview's card builds its area lines from the same text, so
// the two cannot drift apart.
import {
  AREA_LABEL,
  AREA_ORDER,
  type BuildingReadiness,
  type ReadinessArea,
} from "../api/hooks/buildingReadiness";
import { UPLOAD_ID } from "./uploadId";

// The tiles are links down the page, and a citation inside a link cannot be clicked,
// so a summary is shown without its citations: any bracketed span naming a document
// id (read_ledger.BRACKET_RE), quoted, second-hand or not.
const NAMES_UPLOAD = new RegExp(String.raw`(^|[^A-Za-z0-9_-])${UPLOAD_ID}([^A-Za-z0-9_-]|$)`);
const withoutCitations = (text: string): string =>
  text
    .replace(/\s*\[[^[\]]{0,1100}\]/g, (span) =>
      NAMES_UPLOAD.test(span)
        ? ""
        : span,
    )
    .trim();

export const areaSummaryText = (area: ReadinessArea | undefined): string =>
  area?.summary ? withoutCitations(area.summary) : "Nothing recorded yet.";

/** The labels of the area lines the agent's status carries ("ROOF CONDITION: ..."). */
export const AREA_LINE_LABELS = AREA_ORDER.map((key) => AREA_LABEL[key].toUpperCase());

/** One labelled line per area ("STRUCTURAL: <its tile's text>"), in the status's own
 * line format so the status card renders them as it renders any labelled line. */
export const areaLines = (readiness: BuildingReadiness): string =>
  AREA_ORDER.map(
    (key, i) =>
      `${AREA_LINE_LABELS[i]}: ${areaSummaryText(readiness.areas[key]).replace(/\s+/g, " ")}`,
  ).join("\n");
